import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import { Text } from 'components/Text';
import { InstallationImagesBox, InstructionsList } from './styledComponents';

export const InstallationInstructions = ({
  instructions,
  images
}: {
  instructions: string[];
  images: string[];
}) => {
  const theme = useTheme();
  return (
    <Box>
      <Container sx={{ px: '1rem', pb: '1rem' }}>
        <InstructionsList>
          {instructions.map((value: string) => (
            <ListItem
              key={value}
              sx={{
                display: 'list-item',
                padding: '0 0 0 0.2rem',
                color: theme.palette.text.secondary
              }}
            >
              <ListItemText
                sx={{ fontSize: '1rem' }}
                primary={<Text>{value}</Text>}
              />
            </ListItem>
          ))}
        </InstructionsList>
      </Container>

      <InstallationImagesBox>
        {images.map((image: string, index: number) => (
          <img
            key={`Installation image ${index + 1}`}
            alt={`Installation ${index + 1}`}
            src={image}
          />
        ))}
      </InstallationImagesBox>
    </Box>
  );
};
